import { createIcon } from '@chakra-ui/icons';

export const Csv = createIcon({
  displayName: 'Csv',
  viewBox: '0 0 16 16',
  path: [
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83333 10.6666C3.05057 10.6666 2.33333 11.3654 2.33333 12.3333C2.33333 13.3012 3.05057 14 3.83333 14C4.12047 14 4.38998 13.9106 4.62158 13.751L5.17043 13.3726L5.92727 14.4702L5.37842 14.8487C4.93649 15.1534 4.40529 15.3333 3.83333 15.3333C2.22286 15.3333 1 13.9428 1 12.3333C1 10.7238 2.22286 9.33331 3.83333 9.33331C4.40529 9.33331 4.93649 9.51325 5.37842 9.81791L5.92727 10.1964L5.17043 11.294L4.62158 10.9156C4.38998 10.756 4.12047 10.6666 3.83333 10.6666Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9.33331H7.83333C6.8208 9.33331 6 10.1541 6 11.1666C6 12.1792 6.8208 13 7.83333 13H8.83333C9.10947 13 9.33333 13.2238 9.33333 13.5C9.33333 13.7761 9.10947 14 8.83333 14H6.66667V15.3333H8.83333C9.84587 15.3333 10.6667 14.5125 10.6667 13.5C10.6667 12.4874 9.84587 11.6666 8.83333 11.6666H7.83333C7.5572 11.6666 7.33333 11.4428 7.33333 11.1666C7.33333 10.8905 7.5572 10.6666 7.83333 10.6666H10V9.33331Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8362 15.3333H12.1638L10.4495 9.33331H12.0568V10.1055L13 13.4066L13.9477 10.0893V9.33331H15.5505L13.8362 15.3333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.3856 0.666687C6.8552 0.666687 6.34648 0.8774 5.97141 1.25247L2.58579 4.63809C2.21071 5.01317 2 5.52187 2 6.05231V8.00002H14V2.66669C14 1.56212 13.1046 0.666687 12 0.666687H7.3856ZM7.33333 6.00002H3.33333L7.33333 2.00002V6.00002Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
